// extracted by mini-css-extract-plugin
module.exports = {"menuContainer":"app-component-menuContainer__36Jx3","layoutContainer":"app-component-layoutContainer__3iPwi","error":"app-component-error__1Nd97"};